export default function checkKeyInObj<T extends object>(
    obj: T,
    key: string | number | symbol
): key is keyof OmitExtraProps<T> {
    return key in obj;
}
